import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
import { useState } from "react";
import { Snackbar, Alert } from "@mui/material";

function EmailAddressField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");
  // console.log(options);

  return (
    <MDBox>
      <MDBox ml={0.5}>
        <MDTypography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </MDTypography>
      </MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        // label={displayName}
        type="email"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const entryValue = e.target.value;
          const re = /\S+@\S+\.\S+/;
          if (!re.test(entryValue)) {
            e.target.value = null;
            setErrMsg(`${displayName} must be a valid email format.`);
            showFieldError(true);
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

// Typechecking props of the Transaction
EmailAddressField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

EmailAddressField.defaultProps = {
  options: null,
};

export default EmailAddressField;
